import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { baseUrl } from '../api-config';

export interface StatisticheAnnue {
  ricevuti: number,
  evasi: number,
  da_evadere: number,
  riparazioni: number,
  videoperizie: number
}
@Injectable({
  providedIn: 'root'
})
export class StatisticheBaseAnnuaService {

  constructor(private http: HttpClient) { }

  protected ngUnsubscribe: Subject<void> = new Subject<void>();

  getRicevutiEvasiDaEvadere(): Promise<StatisticheAnnue> {
    //unsubscribe from old requests. 
    this.ngUnsubscribe.next();

    return this.http.get<StatisticheAnnue>
      (`${baseUrl}/statistiche/ricevuti_evasi_da_evadere`)
      .pipe(takeUntil(this.ngUnsubscribe))
      .toPromise();
  }
}
